<template>
  <app-autocomplete
    filter
    :items="items"
    :label="$t('permanentDebts.customNumber')"
    label-icon="icon-hash"
    hide-details
    multiple
    dense
    solo
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import { NAMESPACE } from '@/modules/PermanentDebts/store';
import { mapActions } from 'vuex';

export default {
  name: 'SubjectSelect',

  data: () => ({
    items: []
  }),

  methods: mapActions(NAMESPACE, ['fetchFilterCustomNumbers']),

  async created() {
    const { data } = await this.fetchFilterCustomNumbers();
    this.items = data;
  }
};
</script>
